export const reportStyles = `
.qck-root {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  /* Solid (no blur) — one of ~10 card shells stacked on the scrolling
     dashboard grid; blur only frosts the flat page bg (pure raster cost). */
  background: var(--glass-flat-solid);
  border: 1px solid var(--glass-flat-border);
  box-shadow: var(--glass-flat-edge), var(--glass-flat-float-rest);
  border-radius: var(--rad-catchup-large);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.qck-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.qck-title-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}
.qck-title {
  color: var(--text-primary);
  font-weight: var(--font-weight-semi);
  font-size: var(--fs-2xl);
}
.qck-see-all-wrapper {
  cursor: pointer;
}
.qck-see-all {
  color: var(--catchup-blue-600);
  font-weight: var(--font-weight-bold);
  white-space: nowrap;
}
.qck-body {
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
`;
